import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from '../../../../pages/shared/base/components/base-form-page.component';
import { UpdateFilterWordCommand } from './../../../../core/api/models';
import { CreateFilterWordCommand } from './../../../../core/api/models/create-filter-word-command';
import { FilterWordsService } from './../../../../core/api/services/filter-words.service';
import {
  DialogService,
  DialogStatus,
} from './../../../../core/services/dialog.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: 'app-filter-words-form',
    templateUrl: './filter-words-form.component.html',
    imports: [BaseFormModule, ModalTitleComponent]
})
export class FilterWordsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  protected currentService = inject(FilterWordsService);
  model: CreateFilterWordCommand = {};
  //#endregion

  constructor(
    private dialogService: DialogService,

    private dialogRef: MatDialogRef<FilterWordsFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
    if (data.model) this.model = data.model;
  }

  ngOnInit() {
    this.initForm();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      titles: new FormControl(''),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateFilterWordCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .filterWordsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateFilterWordCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .filterWordsUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  //#region final methods

  onSubmit() {
    try {
      if (!this.model.titles.length) {
        this.emptyWordListError();
        return;
      }

      super.onSubmit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  emptyWordListError() {
    this.dialogService.openDialog({
      title: 'common.error',
      message: 'messages.emptyWordList',
      status: DialogStatus.error,
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }

  //#endregion
}
